import { Box, Heading, Button } from '@theme-ui/components';
import styled from '@emotion/styled';
import { Container } from '.';
import { OrangeLine } from '../molecules';
import { SvgBackground } from '../backgrounds';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image';

const CTABlock = ({ regionCode }) => {
	const { infographicsLG, infographicsSM } = useStaticQuery(graphql`
		{
			infographicsLG: file(relativePath: { eq: "module/infographics-lg.png" }) {
				childImageSharp {
					gatsbyImageData(
						width: 786
						layout: CONSTRAINED
					)
				}
			}
			infographicsSM: file(relativePath: { eq: "module/infographics-sm.png" }) {
				childImageSharp {
					gatsbyImageData(
						width: 175
						layout: CONSTRAINED
					)
				}
			}
		}
	`);

	const infographics = withArtDirection(getImage(infographicsLG), [
		{
			media: '(max-width: 830px)',
			image: getImage(infographicsSM),
		},
	]);

	let ctaSlug = '/free-hr-payroll-software/';
	if (regionCode && (regionCode === 'ME' || regionCode === 'SA')) {
		ctaSlug = '/middle-east/free-hr-payroll-software/';
	}

	return (
		<Box sx={{ bg: '#23B4FB', mt: 6 }}>
			<Container
				py={[5]}
				sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
			>
				<OrangeLine />
				<Heading as='h2' sx={headingSX}>
					Free yourself of tedious HR operations.
					<br />
					With the free greytHR Starter Plan.
				</Heading>
				<StyledImgWrapper mt={[4, 5]}>
					<GatsbyImage
						image={infographics}
						alt='free-signup features'
						className='art-directed'
					/>
				</StyledImgWrapper>
				<Link to={ctaSlug}>
					<Button sx={buttonSX}>SIGN UP FOR FREE</Button>
				</Link>
			</Container>
		</Box>
	);
};

const buttonSX = {
	color: 'primary',
	bg: 'white',
	fontSize: ['1rem', '1.125rem'],
	border: '0.5 solid',
	borderColor: 'primary',
	boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
	borderRadius: '8px',
	height: [39, 43],
	width: [207, 228],
	mt: '48px',
	'&:hover': {
		bg: 'white',
	},
};


const headingSX = {
	color: 'white',
	mt: 3,
	textAlign: 'center',
	width: [263, 'auto'],
	fontSize: ['1.5rem', '2.25rem'],
	lineHeight: ['30px', '47.09px'],
};

const StyledImgWrapper = styled(Box)`
	.art-directed {
		width: 786px;
		height: 182px;
	}
	@media (max-width: 830px) {
		.art-directed {
			width: 175px;
			height: 660px;
		}
	}
`;

export default CTABlock;
